export default __webpack_public_path__ + "images/edb1182941924e184baabe685ced9c0c-heritage.webp";